"use client";

import Image from "next/image";
import { Fragment, useState } from "react";
import { Icon } from "../_family/Icon";
import { TRAVELLER } from "./colour";
import { SEES } from "./words";

type Said = "yes" | "no";

function Face() {
  return (
    <span className="face">
      <Image
        src="/developers/family/face-bash.webp"
        width={320}
        height={320}
        alt=""
        unoptimized
      />
    </span>
  );
}

/**
 * What traveller-42 sees in your app, complete as the page loads: the card for book_flight's approval and
 * Bash's reply after the yes. The reader may answer it: Yes turns calmly to Booked, Not now to Not booked,
 * and Bash's reply follows the answer.
 */
export function HeroCard() {
  const [said, setSaid] = useState<Said | null>(null);

  return (
    <div className="hx-sees">
      <h2 className="hx-sees-h">{SEES.title}</h2>
      <div className={said ? `hx-card said-${said}` : "hx-card"}>
        <div className="hx-card-head">
          <Face />
          <span>
            {SEES.asks} <b>{TRAVELLER}</b>
          </span>
          <em>{said ? SEES.answered : SEES.waits}</em>
        </div>
        <p className="hx-card-says">{SEES.says}</p>
        {/* A row per input book_flight is called with: the label is the input's own name. */}
        <dl className="hx-rows">
          {SEES.rows.map((r) => (
            <Fragment key={r.label}>
              <dt>{r.label}</dt>
              <dd>{r.value}</dd>
            </Fragment>
          ))}
        </dl>
        <div className="hx-acts">
          <button
            className="btn hx-yes"
            type="button"
            aria-pressed={said === "yes"}
            onClick={() => setSaid("yes")}
          >
            {said === "yes" && <Icon name="check" />}
            {said === "yes" ? SEES.booked : SEES.yes}
          </button>
          <button
            className="btn btn-soft hx-no"
            type="button"
            aria-pressed={said === "no"}
            onClick={() => setSaid("no")}
          >
            {said === "no" ? SEES.notBooked : SEES.no}
          </button>
        </div>
      </div>
      <p className="hx-reply" aria-live="polite">
        <Face />
        <span>{SEES.reply[said ?? "yes"]}</span>
      </p>
    </div>
  );
}
